// Creates a name for the title for title tag
export function getName(personaName, templateName){
  let name = 'Blank';
  if (templateName && templateName.length > 0){
    name = templateName;
  }
  if (personaName && personaName.length > 0) {
    name = personaName;
  }
  return name;
}

// Creates a description for meta description
export function getDescription(personaDescription, templateDescription){
  let description = 'A description for a soon to be created persona on PersonaGenerator.';
  if (templateDescription && templateDescription.length > 0){
    description = templateDescription.substring(0,160);
  }
  if (personaDescription && personaDescription.length > 0) {
    description = personaDescription.substring(0,160);
  }
  return description;
}



// WEBPACK FOOTER //
// ./client/utilities/contentHelpers.js